module.exports = __webpack_public_path__ + "img/google.9bcd611e.png";